import apiService from '../infrastructure/api.service.js';
import authStorageService from "../auth/auth-storage.service.js";

export const branchService = {
    createBranch,
    getCollectionPoints: getCollectionPoints,
    editBranch,
    getBranch,
    logout
};

export const state = { status: false };

async function createBranch(shop) {
    return apiService.post('/shop/save', shop);
}

async function getCollectionPoints() {
    return apiService.get('/collectionPoints');
}

async function getBranch(organizationID, branchID) {
    return apiService.get(`/shops/${organizationID}/${branchID}`);
}

async function editBranch(shop) {
    return apiService.post('/shop/edit', shop);
}

function logout() { 
    authStorageService.clearAuthData();
}